import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translation, formatMoney } from 'helpers/utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import Loader from 'Loader.js';
import Pagination from 'Pagination.js';
import ProgressCircularBar from 'ProgressCircularBar.js';
import S from 'StyledAccountHistoryBonus.js';
import ReactTooltip from 'react-tooltip';
import {
  fetchBonusListByFilter,
  setCurrentPage,
  fetchBonusListPending,
  fetchBonusListFulfilled,
  fetchBonusListFailure,
} from 'accountBonusActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountHistoricalBonus extends Component {
  componentDidMount = async () => {
    const { fetchCreditBonusListByFilter, processFrontError } = this.props;
    try {
      await fetchCreditBonusListByFilter({ activeTab: 'history' });
    } catch (error) {
      processFrontError(error, 'AccountHistoricalBonus.componentDidMount');
    }
  };

  goPage = (currentPage) => {
    const { fetchCreditBonusListByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCreditBonusListByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountHistoricalBonus.goPage');
    }
  };

  render() {
    const { isPending, bonus, limit, currencyCode } = this.props;
    const { data, currentPage, isNextPageAvailable } = bonus.history;
    return (
      <S.AccountHistoryBonus className="account-history-bonus">
        {isPending ? (
          <Loader />
        ) : (
          <>
            <S.BonusList>
              <S.BonusListHeader>{translation('account_bonus_tableHistorical')}</S.BonusListHeader>
              <S.Table>
                <S.Thead>
                  <S.Tr>
                    <S.Th>{translation('account_bonus_name')}</S.Th>
                    <S.Th>{translation('account_bonus_activatedDate')}</S.Th>
                    <S.Th>{translation('account_bonus_completedDate')}</S.Th>
                    <S.Th>{translation('account_bonus_amount')}</S.Th>
                    <S.Th>{translation('account_bonus_totalToWager')}</S.Th>
                    <S.Th>{translation('account_bonus_leftToWager')}</S.Th>
                    <S.Th>{translation('account_bonus_wageredPercent')}</S.Th>
                    <S.Th>
                      <span className="ion ion-help-circled"></span>
                    </S.Th>
                  </S.Tr>
                </S.Thead>
                <S.Tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map(
                        ({
                          offerName,
                          activationTime,
                          statusUpdatedOn,
                          maxBonusAmount,
                          totalToWager,
                          leftToWager,
                          wageredPercent,
                          wagerBonusId,
                          descriptionKey,
                        }) => {
                          return (
                            <S.Tr key={wagerBonusId}>
                              <S.Td className="td">
                                <span>{offerName}</span>
                              </S.Td>
                              <S.Td>
                                <span>{formatDate(activationTime, 'yyyy-MM-dd HH:mm')}</span>
                              </S.Td>
                              <S.Td>
                                <span>{formatDate(statusUpdatedOn, 'yyyy-MM-dd HH:mm')}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(maxBonusAmount)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(totalToWager)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td>
                                <span className="ammount">{formatMoney(leftToWager)}</span>&nbsp;
                                <span className="currency">{currencyCode}</span>
                              </S.Td>
                              <S.Td className="wageredPercent">
                                <S.ProgressCircularWrapper>
                                  <ProgressCircularBar percentage={wageredPercent} />
                                </S.ProgressCircularWrapper>
                              </S.Td>
                              <S.Td>
                                <a
                                  data-tip
                                  data-for={`bonus_desc_${wagerBonusId}`}
                                  className="ion ion-help-circled"
                                ></a>
                                <ReactTooltip id={`bonus_desc_${wagerBonusId}`} type="light">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: translation(descriptionKey),
                                    }}
                                  ></span>
                                </ReactTooltip>
                              </S.Td>
                            </S.Tr>
                          );
                        }
                      )}
                      <S.Tr>
                        <S.Td colSpan="8" className="pagination">
                          <Pagination
                            {...{
                              currentPage,
                              limit,
                              data,
                              isNextPageAvailable,
                              callback: this.goPage,
                            }}
                          />
                        </S.Td>
                      </S.Tr>
                    </>
                  ) : (
                    <S.NoResult>
                      <S.Td colSpan="8">{translation('account_bonus_notNound')}</S.Td>
                    </S.NoResult>
                  )}
                </S.Tbody>
              </S.Table>
            </S.BonusList>
          </>
        )}
      </S.AccountHistoryBonus>
    );
  }
}

const mapStateToProps = ({
  AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBonusListByFilter: bindActionCreators(fetchBonusListByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchBonusListPending: bindActionCreators(fetchBonusListPending, dispatch),
    fetchBonusListFulfilled: bindActionCreators(fetchBonusListFulfilled, dispatch),
    fetchBonusListFailure: bindActionCreators(fetchBonusListFailure, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountHistoricalBonus);
